<template>
  <div class="extension__form__inside">
    <div v-for="field in fields" :key="field.name" v-if="resolveConditions(field)" :class="[{ 'has-error' : !hasErrors(field, object[field.name]) }]">
      <field :field="field" v-model="object[field.name]" :object="object"></field>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Field';
import { sluggify } from '@/helpers/string';
import { hasErrors } from '@/helpers/validation';

export default {
  name: 'standard-form',
  components: {
    Field,
  },
  props: ['fields', 'object'],
  methods: {
    hasErrors,
    resolveConditions(field) {
      if (!field.conditions) {
        return true;
      }

      let result = true;
      field.conditions.forEach(condition => {
        if (condition.comparison === '==') {
          if (this.object[condition.field] !== condition.value) {
            if (condition.relation === '&&') {
              result = false;
            }
          } else if (condition.relation === '||') {
            result = true;
          }
        }
        if (condition.comparison === '!=') {
          if (this.object[condition.field] === condition.value) {
            if (condition.relation === '&&') {
              result = false;
            }
          } else if (condition.relation === '||') {
            result = true;
          }
        }
      });
      return result;
    },
  },
  watch: {
    object: {
      handler(value) {
        // Special handlers
        this.fields.forEach(field => {
          if (field.sluggify) {
            value[field.sluggify] = sluggify(value[field.name]);
          }
        });
      },
      deep: true,
    },
  },
};
</script>
